import { render, staticRenderFns } from "./ProjectUnitTypeFeatures.vue?vue&type=template&id=55345d9e"
import script from "./ProjectUnitTypeFeatures.vue?vue&type=script&lang=js"
export * from "./ProjectUnitTypeFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports